import React from 'react';
import { List } from '@landr/maestro';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';
import {
    ContentSuggestionPayload,
    ContentSuggestionValue,
    Suggestions,
    isContentSuggestion,
} from 'components/Filters/context/SearchBarContext/types';
import { ModifiersPayload } from 'controllers/SearchController/types';
import SuggestionItem from './SuggestionItem';
import { ContentSuggestionItem } from './ContentSuggestionItem';

export const _SuggestionsList = ({
    suggestions,
    selectedSuggestionIndex,
}: {
    suggestions: Suggestions[];
    selectedSuggestionIndex: number;
}) => {
    const hasNoSuggestion = !suggestions || suggestions.length === 0;

    if (hasNoSuggestion) {
        return null;
    }

    return (
        <List
            width="100%"
            maxWidth="100%"
            pb="sm"
            paddingTop={{ base: 0, md: '2xs' }}
        >
            {suggestions?.map((suggestion, index) => {
                switch (true) {
                    case isContentSuggestion(suggestion): {
                        const [[params, value], suggestionType] = suggestion;

                        const { slug, name, artworkUrl } =
                            value as ContentSuggestionValue;

                        const modifiers = [
                            params,
                            {
                                slug,
                                name,
                                artworkUrl,
                            },
                        ] as ContentSuggestionPayload;

                        return (
                            <ContentSuggestionItem
                                key={`suggestion-${params}-${slug}-${suggestionType}`}
                                modifiers={modifiers}
                                suggestionType={suggestionType}
                                isSelected={index === selectedSuggestionIndex}
                            />
                        );
                    }
                    default: {
                        const [[params, code], suggestionType] = suggestion;

                        const modifiers = [params, code] as ModifiersPayload;

                        return (
                            <SuggestionItem
                                key={`suggestion-${params}-${code}-${suggestionType}`}
                                modifiers={modifiers}
                                suggestionType={suggestionType}
                                isSelected={index === selectedSuggestionIndex}
                            />
                        );
                    }
                }
            })}
        </List>
    );
};

const SuggestionsList = () => {
    const { suggestions, selectedSuggestionIndex } = useSearchBarContext();

    return (
        <_SuggestionsList
            suggestions={suggestions}
            selectedSuggestionIndex={selectedSuggestionIndex}
        />
    );
};

export default SuggestionsList;
